export default __webpack_public_path__ + "static/media/back_piece1.5.e7f30ee0.png";